export default {
      id: "user-white-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "sprite.svg#user-white",
      toString: function () {
        return this.url;
      }
    }